import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './helpers';
import clsx from 'clsx';

const DialogAccept = ({openModal, setOpenModal, submit}) => {
    const classes = useStyles();

    return (
        <Dialog onClose={() => setOpenModal(false)} open={openModal}>
            <div className={classes.wrapDialog}>
                <h3 className={classes.titleDialog}>Подтвердите свое дествие</h3>
                <div className={classes.wrap}>
                    <span className={clsx(classes.dialogButton, classes.ok)}
                    
                        onClick={() => {
                            submit({
                                type: 'accept'
                            })
                        }}
                    >
                        ОК
                    </span>
                    <span 
                        className={clsx(classes.dialogButton, classes.cancel)}
                        onClick={() => {
                            setOpenModal(false);
                        }}
                    >
                        Отмена
                    </span>
                </div>
                
            </div>
        </Dialog>
    )
}

export default DialogAccept;